import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 12.5L10 7.5L15 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronUp;
